import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

interface AnimatedLayoutProps {
  children: React.ReactNode;
}

export function AnimatedLayout({ children }: AnimatedLayoutProps) {
  return (
    <div className="relative flex min-h-screen flex-col">
      {children}
      <Analytics />
      <SpeedInsights />
    </div>
  );
}
